import { LayoutBlock } from '@/layout';
import { RouteConfig } from 'vue-router';

const mainRouting: RouteConfig[] = [
    {
        path: 'main',
        component: LayoutBlock,
        meta: { title: '系统' },
        redirect: '/app/main/dashboard',
        children: [
            {
                path: 'dashboard',
                name: 'dashboard',
                component: () => import('./dashboard/dashboard.vue'),
                meta: { title: '工作台' },
            },
            {
                path: 'update-log',
                name: 'updateLog',
                component: () => import('./update-log/update-log.vue'),
                meta: { title: '系统更新日志' },
            },
        ],
    },
];

export default mainRouting;
